import type { Module } from 'vuex';
import { users } from '@contimo/api/src/api';
import type { TRootStore } from '@/store';
import { INIT_USER, GET_USER, INIT_MERCHANT } from '../actionTypes';
import { SET_USER } from '../mutationsTypes';
import { IS_ADMIN, IS_CUSTOMER, IS_MANAGER, THIS_USER } from '../gettersTypes';

export interface IUserStoreState {
  user: null | {
    manager: any;
    customer: any;
    isAdmin: boolean;
  };
}

type TUserStore = Module<IUserStoreState, TRootStore>;

const userStore: TUserStore = {
  state: () => ({
    user: null,
  }),

  getters: {
    [IS_MANAGER]: (state) => {
      if (state.user?.manager) {
        return true;
      }
      return false;
    },
    [IS_CUSTOMER]: (state) => {
      if (state.user?.customer) {
        return true;
      }
      return false;
    },
    [IS_ADMIN]: (state) => state.user?.isAdmin,
    [THIS_USER]: (state) => state.user,
  },

  mutations: {
    [SET_USER](state, user) {
      state.user = user;
    },
  },

  actions: {
    async [GET_USER]({ commit, dispatch }, id) {
      const { data } = await users.show(id);
      commit(SET_USER, data);
      if (data.manager) {
        await dispatch(INIT_MERCHANT, data.manager.merchantId);
      }
    },
    async [INIT_USER]({ commit, dispatch }, user) {
      commit(SET_USER, user);
      await dispatch(GET_USER, user.id);
    },
  },
};

export default userStore;
